import { useMemo } from "react";
import { BillActivity } from "../../../api/services";
import { useRouteMatch } from "react-router-dom";
import { formatMoneyWithSign } from "../../../utils/formatMoney";
import { formatBillPeriod } from "../../Financials/utils/formatBillPeriod";

const getBillType = (isFinal: boolean, requestType: string) => {
  if (isFinal) {
    return "Final Bill";
  } else if (requestType === "Hot") {
    return "Hot Bill";
  } else if (requestType === "NewVersion") {
    return "Bill (New Version)";
  }
  return "Bill";
};

export const useBillActivity = (activity: BillActivity) => {
  const {
    billNumber,
    isFinal,
    requestType,
    currency,
    grossAmount,
    fromDttm,
    toDttm,
  } = activity;

  const { url } = useRouteMatch();

  return useMemo(() => {
    const billType = getBillType(isFinal, requestType);
    const amount = formatMoneyWithSign(currency, grossAmount);
    const billPeriod = formatBillPeriod(fromDttm, toDttm);
    return {
      billPeriod,
      title: `${billType}: ${amount}`,
      link: `${url}/bills/${billNumber}`,
    };
  }, [
    isFinal,
    requestType,
    currency,
    grossAmount,
    fromDttm,
    toDttm,
    url,
    billNumber,
  ]);
};
